module.exports = __webpack_public_path__ + "static/media/link-arrow.284bab36.svg";